import * as React from 'react'
import { Block } from 'baseui/block';
import { Input } from "baseui/input";
import { LabelLarge } from 'baseui/typography';   
import { IMultisensor } from './types'
// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';

export const ConfigurationPanel = (props: IMultisensor) => {

    const [presenceDelay, setPresenceDelay, setPresenceDelayResult] = useSetObjectValue(props.id, props.resourceGroupId,"presenceOffDelay", props.presenceOffDelay);
    const onValueChanged = (e: any) => setPresenceDelay(parseFloat(e.target.value));

    return (
        <>
        <Block gridRowGap='20px' display='flex' flexDirection='column' >
            <LabelLarge><FormattedMessage id="Devices.PresenceOffDelay" defaultMessage="Presence Off Delay" /></LabelLarge>    
            <Input
                    value={presenceDelay}  
                    onChange={onValueChanged}
                    placeholder="[s]"
                    disabled={setPresenceDelayResult.isLoading}
                    error={setPresenceDelayResult.isError}
            />
        
        </Block>
        </>
    )
}
